
const ENTER_KEY_PRESSED = 'enter-key-pressed';

const LOAN_TENURE_OPTIONS = [3, 6, 9, 12, 18, 24, 36];

export {
   ENTER_KEY_PRESSED,
   LOAN_TENURE_OPTIONS
}